import { render, staticRenderFns } from "./ViewSwitcher.vue?vue&type=template&id=a8b14c82&scoped=true&"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js&"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ViewSwitcher.vue?vue&type=style&index=0&id=a8b14c82&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b14c82",
  null
  
)

export default component.exports